import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import DictionaryView from '../components/chat/DictionaryView';
import AddWordModal from '../components/dictionary/AddWordModal';
import { FaBook, FaBolt } from 'react-icons/fa';

const DictionaryPage: React.FC = () => {
  const { t } = useTranslation();
  const { selectedLanguage } = useLanguage();
  const navigate = useNavigate();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Get user's native language from localStorage
  const getNativeLanguage = (): string => {
    const userOptionsString = localStorage.getItem('userOptions');
    if (userOptionsString) {
      const userOptions = JSON.parse(userOptionsString);
      return userOptions.user_native_language || 'en-US';
    }
    return 'en-US';
  };

  const handleWordAdded = () => {
    // Trigger a refresh of the dictionary view
    setRefreshTrigger(prev => prev + 1);
  };

  if (!selectedLanguage) {
    return (
      <div className="flex flex-col items-center justify-center h-full p-8 pt-24 pb-24">
        <FaBook size={64} className="text-base-content opacity-20 mb-4" />
        <p className="text-lg text-base-content opacity-60">
          {t('languageSelector.pleaseSelect')}
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-y-auto pt-16 pb-[7rem]">
        <div className="px-2 sm:px-4 space-y-4">
          <div className="flex justify-end">
            <button
              onClick={() => navigate('/review')}
              className="btn btn-secondary btn-sm gap-2"
            >
              <FaBolt /> {t('review.startReview')}
            </button>
          </div>
          <DictionaryView
            language={selectedLanguage.iso639_tag}
            refreshTrigger={refreshTrigger}
            onRequestAddWord={() => setIsAddModalOpen(true)}
          />
        </div>
      </div>

      <AddWordModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onWordAdded={handleWordAdded}
        currentLanguage={selectedLanguage.iso639_tag}
        nativeLanguage={getNativeLanguage()}
      />
    </div>
  );
};

export default DictionaryPage;

